export function CountupModule() {

    var CountUp = {
        interval: undefined,
        totalSeconds: 0,
        lastSeconds: 0,
    };

    CountUp.startTimer = function () {
        var CU = this;
        this.interval = setInterval(function() {
            CU.setTime();
        }, 1000);
    };

    CountUp.setTime = function () {
        this.totalSeconds++;
        var seconds = document.querySelector('.count-up-seconds');
        var minutes = document.querySelector('.count-up-minutes');
        var hours = document.querySelector('.count-up-hours');

        seconds.innerHTML = this.pad(this.totalSeconds % 60);
        minutes.innerHTML = this.pad(parseInt(this.totalSeconds / 60));
        hours.innerHTML = this.pad(parseInt(this.totalSeconds / 3600));
    };

    CountUp.stopTimer = function () {
        clearInterval(this.interval);
        this.lastSeconds = this.totalSeconds;
        this.totalSeconds = 0;
        document.querySelector('.count-up-seconds').innerHTML = ('00');
        document.querySelector('.count-up-minutes').innerHTML = ('00');
        document.querySelector('.count-up-hours').innerHTML = ('00');
    };

    CountUp.getSeconds = function() {
        return (this.totalSeconds) ? this.totalSeconds : this.lastSeconds;
    };

    CountUp.pad = function (val) {
        var valString = val + "";
        if (valString.length < 2) {
            return "0" + valString;
        } else {
            return valString;
        }
    };

    return CountUp;

}